import { computed } from "vue";
import { useStore } from "vuex";
import { PERMISSIONS } from "@/constants.js";

export const useApiEmployeePermissions = () => {
  const store = useStore();

  const userPermissions = computed(
    () => store.state?.currentUser?.permissions ?? []
  );

  const hasApiEmployeeStudentViewPermission = computed(() =>
    userPermissions.value.includes(PERMISSIONS.API_EMPLOYEE_STUDENT_VIEW)
  );

  return {
    userPermissions,
    hasApiEmployeeStudentViewPermission,
  };
};
